const fsdProjects = [
  {
    id: "ecommerce-web-application",
    title: "E-Commerce Web Application",
    category: "Full Stack",
    domain: "Retail & E-Commerce",
    difficulty: "Advanced",
    duration: "8-10 Weeks",
    price: "₹3999",
    shortDescription:
      "A complete online store with product catalog, cart, checkout, order tracking and an admin panel.",
    description:
      "Build a production-ready e-commerce platform with a customer storefront, cart and checkout flow, order tracking, and a full admin dashboard for managing products, categories and orders.",
    technologies: [
      "React",
      "Redux",
      "Node.js",
      "Express.js",
      "MySQL",
      "Stripe / Razorpay",
    ],
    skills: [
      "Schema Design",
      "Wireframing",
      "React & Redux",
      "REST API Development",
      "Payment Gateway Integration",
      "Deployment",
    ],
    features: [
      "Product catalog",
      "Shopping cart & checkout",
      "Order tracking",
      "Admin dashboard",
      "Payment integration",
      "Order history",
    ],
    suitableFor: ["BCA", "MCA", "B.Tech", "BE", "MSc CS"],
  },

  {
    id: "food-delivery-application",
    title: "Food Delivery Application",
    category: "Full Stack",
    domain: "Food Delivery",
    difficulty: "Advanced",
    duration: "8-10 Weeks",
    price: "₹3999",
    shortDescription:
      "A food ordering platform with restaurant listings, menus, cart and live order tracking.",
    description:
      "Develop a full food delivery system with a customer app for browsing restaurants and placing orders, plus restaurant and delivery-agent dashboards, with real-time order status updates via WebSockets.",
    technologies: [
      "React",
      "React Native",
      "Node.js",
      "Express.js",
      "MongoDB Atlas",
      "Socket.IO",
    ],
    skills: [
      "Real-Time Architecture",
      "WebSocket Communication",
      "Geolocation Search",
      "Schema Design",
      "Push Notifications",
      "Deployment",
    ],
    features: [
      "Restaurant listings",
      "Menu browsing",
      "Cart & checkout",
      "Live order tracking",
      "Restaurant dashboard",
      "Delivery agent panel",
    ],
    suitableFor: ["BCA", "MCA", "B.Tech", "BE", "MSc CS"],
  },

  {
    id: "realtime-chat-messaging-app",
    title: "Real-Time Chat and Messaging Application",
    category: "Full Stack",
    domain: "Communication",
    difficulty: "Advanced",
    duration: "8-10 Weeks",
    price: "₹3999",
    shortDescription:
      "One-to-one and group chat with media sharing, online status, typing indicators and read receipts.",
    description:
      "Build a real-time messaging platform supporting private and group conversations, media sharing and presence tracking — with read receipts and typing indicators powered by Socket.IO.",
    technologies: [
      "React",
      "Node.js",
      "Express.js",
      "Socket.IO",
      "MongoDB",
      "Redis",
    ],
    skills: [
      "Real-Time Architecture",
      "Socket.IO",
      "Presence Tracking",
      "Schema Design",
      "Concurrency Handling",
      "Deployment",
    ],
    features: [
      "One-to-one chat",
      "Group chat",
      "Media sharing",
      "Online status",
      "Typing indicators",
      "Read receipts",
    ],
    suitableFor: ["MCA", "B.Tech", "BE", "MSc CS"],
  },

  {
    id: "job-portal-recruitment-platform",
    title: "Job Portal and Recruitment Platform",
    category: "Full Stack",
    domain: "Career Technology",
    difficulty: "Advanced",
    duration: "8-10 Weeks",
    price: "₹3999",
    shortDescription:
      "A recruitment platform with job listings, resume uploads, application tracking and an employer dashboard.",
    description:
      "Build a full recruitment platform where employers post jobs, candidates apply with resumes, and applications flow through a tracked status pipeline — with full-text search across jobs and profiles.",
    technologies: [
      "React",
      "Node.js",
      "Express.js",
      "MongoDB Atlas",
      "Elasticsearch",
      "AWS S3",
    ],
    skills: [
      "Full-Text Search",
      "File Uploads",
      "Schema Design",
      "Application Workflow",
      "Resume Parsing",
      "Deployment",
    ],
    features: [
      "Job listings & search",
      "Resume upload",
      "Application tracking",
      "Employer dashboard",
      "Candidate profiles",
      "Filters & search relevance",
    ],
    suitableFor: ["MCA", "B.Tech", "BE", "MSc CS"],
  },

  {
    id: "recipe-sharing-meal-planning",
    title: "Recipe Sharing and Meal Planning Platform",
    category: "Full Stack",
    domain: "Food & Lifestyle",
    difficulty: "Intermediate",
    duration: "6-8 Weeks",
    price: "₹2999",
    shortDescription:
      "Share recipes, search by ingredient and plan weekly meals with ratings and reviews.",
    description:
      "Create a recipe community platform where users upload recipes, search by ingredients, build meal plans and rate each other's dishes — with full-text ingredient search.",
    technologies: [
      "React",
      "Node.js",
      "Express.js",
      "PostgreSQL",
      "Cloudinary",
      "Bootstrap",
    ],
    skills: [
      "Full-Text Search",
      "Schema Design",
      "Image Uploads",
      "Rating Aggregation",
      "React Development",
      "Deployment",
    ],
    features: [
      "Recipe upload",
      "Ingredient search",
      "Meal planner",
      "Ratings & reviews",
      "Image storage",
      "User profiles",
    ],
    suitableFor: ["BCA", "MCA", "B.Tech", "BE"],
  },

  {
    id: "fitness-workout-tracking",
    title: "Fitness and Workout Tracking Application",
    category: "Full Stack",
    domain: "Health & Fitness",
    difficulty: "Intermediate",
    duration: "6-8 Weeks",
    price: "₹2999",
    shortDescription:
      "Log workouts, track progress with charts, set goals and follow structured workout plans.",
    description:
      "Develop a fitness tracker where users log workouts, view progress charts, set and track goals, and follow structured plans — built as a PWA for a mobile-like experience.",
    technologies: [
      "React",
      "Recharts",
      "Node.js",
      "Express.js",
      "MongoDB",
      "PWA",
    ],
    skills: [
      "Data Visualization",
      "Schema Design",
      "Progress Calculations",
      "PWA Setup",
      "React Development",
      "Deployment",
    ],
    features: [
      "Workout logging",
      "Progress charts",
      "Goal setting & tracking",
      "Workout plans",
      "Dashboard with charts",
      "PWA support",
    ],
    suitableFor: ["BCA", "MCA", "B.Tech", "BE"],
  },

  {
    id: "expense-budget-tracker",
    title: "Personal Expense and Budget Tracker",
    category: "Full Stack",
    domain: "Personal Finance",
    difficulty: "Intermediate",
    duration: "6-8 Weeks",
    price: "₹2999",
    shortDescription:
      "Track expenses, categorize spending, set budgets and view monthly reports with graphs.",
    description:
      "Build a personal finance tracker with expense entry, categorization, monthly budgets, alerts on thresholds and downloadable reports with visual charts.",
    technologies: [
      "React",
      "Chart.js",
      "Node.js",
      "Express.js",
      "PostgreSQL",
      "Nodemailer",
    ],
    skills: [
      "Data Visualization",
      "Schema Design",
      "Scheduled Jobs",
      "Report Generation",
      "React Development",
      "Deployment",
    ],
    features: [
      "Expense entry",
      "Category management",
      "Budget limits & alerts",
      "Monthly reports",
      "Charts & analytics",
      "Email report schedule",
    ],
    suitableFor: ["BCA", "MCA", "B.Tech", "BE"],
  },

  {
    id: "event-booking-ticketing",
    title: "Event Booking and Ticketing Platform",
    category: "Full Stack",
    domain: "Events",
    difficulty: "Advanced",
    duration: "8-10 Weeks",
    price: "₹3999",
    shortDescription:
      "List events, sell tickets with seat selection, handle payments and refunds.",
    description:
      "Build a full event ticketing system with event listings, seat selection, concurrent-safe booking, payment gateway integration and a refund workflow.",
    technologies: [
      "React",
      "Node.js",
      "Express.js",
      "MySQL",
      "Stripe / Razorpay",
      "Webhooks",
    ],
    skills: [
      "Seat Locking",
      "Concurrency Handling",
      "Payment Gateway Integration",
      "Webhook Handling",
      "Schema Design",
      "Deployment",
    ],
    features: [
      "Event listings",
      "Seat selection UI",
      "Concurrent-safe booking",
      "Payment & refunds",
      "Webhook handling",
      "Booking history",
    ],
    suitableFor: ["MCA", "B.Tech", "BE", "MSc CS"],
  },

  {
    id: "portfolio-resume-builder",
    title: "Portfolio and Resume Builder Platform",
    category: "Full Stack",
    domain: "Career Technology",
    difficulty: "Advanced",
    duration: "8-10 Weeks",
    price: "₹3999",
    shortDescription:
      "Drag-and-drop portfolio builder with templates, live preview and PDF export.",
    description:
      "Create a portfolio builder where users drag-and-drop sections into templates, preview their portfolio live, publish to a custom subdomain and export a PDF resume.",
    technologies: [
      "React",
      "Node.js",
      "Express.js",
      "MongoDB",
      "Puppeteer",
      "Vercel",
    ],
    skills: [
      "Drag-and-Drop UI",
      "PDF Generation",
      "Auto-Save Logic",
      "Subdomain Hosting",
      "React Development",
      "Deployment",
    ],
    features: [
      "Drag-and-drop editor",
      "Templates",
      "Live preview",
      "PDF export",
      "Auto-save",
      "Custom subdomain hosting",
    ],
    suitableFor: ["BCA", "MCA", "B.Tech", "BE"],
  },

  {
    id: "url-shortener-analytics",
    title: "URL Shortener and Link Analytics Platform",
    category: "Full Stack",
    domain: "Developer Tools",
    difficulty: "Advanced",
    duration: "8-10 Weeks",
    price: "₹3999",
    shortDescription:
      "Shorten URLs, use custom aliases, track clicks with analytics and generate QR codes.",
    description:
      "Develop a URL shortener service with custom aliases, QR code generation and a full analytics dashboard tracking clicks, geography and device types behind a Redis-cached redirect layer.",
    technologies: [
      "React",
      "Node.js",
      "Express.js",
      "Redis",
      "MongoDB",
      "CDN",
    ],
    skills: [
      "Redis Caching",
      "Redirect Architecture",
      "Analytics Tracking",
      "Alias Collision Handling",
      "QR Code Generation",
      "Deployment",
    ],
    features: [
      "URL shortening",
      "Custom aliases",
      "Click analytics",
      "QR code generation",
      "Geographic tracking",
      "Fast redirects",
    ],
    suitableFor: ["MCA", "B.Tech", "BE", "MSc CS"],
  },

  {
    id: "weather-forecast-alert-dashboard",
    title: "Weather Forecast and Alert Dashboard",
    category: "Full Stack",
    domain: "Utilities",
    difficulty: "Intermediate",
    duration: "6-8 Weeks",
    price: "₹2999",
    shortDescription:
      "Location-based weather forecast with alerts, historical trends, charts and maps.",
    description:
      "Build a weather dashboard where users save locations, view forecasts and historical trends on charts and maps, and receive alerts when thresholds are crossed.",
    technologies: [
      "React",
      "Chart.js",
      "Node.js",
      "Express.js",
      "Weather API",
      "MongoDB",
    ],
    skills: [
      "Third-Party API Integration",
      "API Caching",
      "Alert Thresholds",
      "Data Visualization",
      "Scheduled Jobs",
      "Deployment",
    ],
    features: [
      "Location-based forecasts",
      "Weather alerts",
      "Historical trends",
      "Charts & maps",
      "Saved locations",
      "Scheduled alert notifications",
    ],
    suitableFor: ["BCA", "MCA", "B.Tech", "BE"],
  },

  {
    id: "movie-tv-recommendation",
    title: "Movie and TV Show Recommendation Platform",
    category: "Full Stack",
    domain: "Entertainment",
    difficulty: "Advanced",
    duration: "8-10 Weeks",
    price: "₹3499",
    shortDescription:
      "Browse movies, rate titles, maintain watchlists and get personalized recommendations.",
    description:
      "Build a movie discovery platform with ratings, watchlists and a collaborative-filtering recommendation engine, backed by a public movie database API with server-side caching.",
    technologies: [
      "React",
      "Node.js",
      "Express.js",
      "MongoDB",
      "TMDB API",
      "Recommendation Engine",
    ],
    skills: [
      "Collaborative Filtering",
      "API Caching",
      "Rating Aggregation",
      "Schema Design",
      "React Development",
      "Deployment",
    ],
    features: [
      "Movie & TV browsing",
      "Ratings",
      "Watchlists",
      "Personalized recommendations",
      "API response caching",
      "User profiles",
    ],
    suitableFor: ["MCA", "B.Tech", "BE", "MSc CS"],
  },

  {
    id: "music-streaming-playlist",
    title: "Music Streaming and Playlist Platform",
    category: "Full Stack",
    domain: "Entertainment",
    difficulty: "Advanced",
    duration: "8-10 Weeks",
    price: "₹3999",
    shortDescription:
      "Stream music, build playlists, reorder tracks and persist playback state across sessions.",
    description:
      "Develop a music streaming platform with an in-browser audio player, playlist management, likes and CDN-backed audio delivery for smooth streaming.",
    technologies: [
      "React",
      "Node.js",
      "Express.js",
      "MongoDB",
      "AWS S3",
      "CloudFront",
    ],
    skills: [
      "Audio Streaming Architecture",
      "CDN Delivery",
      "Playback State Management",
      "Playlist Management",
      "React Development",
      "Deployment",
    ],
    features: [
      "Song browsing",
      "Playlist creation",
      "Audio streaming",
      "Likes & favorites",
      "Playback persistence",
      "Artist pages",
    ],
    suitableFor: ["MCA", "B.Tech", "BE", "MSc CS"],
  },

  {
    id: "hotel-booking-reservation",
    title: "Hotel Booking and Reservation Web Application",
    category: "Full Stack",
    domain: "Hospitality",
    difficulty: "Advanced",
    duration: "8-10 Weeks",
    price: "₹3999",
    shortDescription:
      "Search rooms, check availability, book with payment and handle cancellations with refunds.",
    description:
      "Build a hotel reservation system with room search, availability calendar, booking with availability locking to prevent double-booking, payment integration and a full refund flow.",
    technologies: [
      "React",
      "Node.js",
      "Express.js",
      "MySQL",
      "Stripe / Razorpay",
      "Redis",
    ],
    skills: [
      "Availability Locking",
      "Date-Range Logic",
      "Caching Search Results",
      "Payment Integration",
      "Refund Workflow",
      "Deployment",
    ],
    features: [
      "Room search",
      "Availability calendar",
      "Prevent double-booking",
      "Payment integration",
      "Cancellation & refund",
      "Booking history",
    ],
    suitableFor: ["MCA", "B.Tech", "BE", "MSc CS"],
  },

  {
    id: "healthcare-appointment-system",
    title: "Healthcare Appointment Booking System",
    category: "Full Stack",
    domain: "Healthcare",
    difficulty: "Advanced",
    duration: "8-10 Weeks",
    price: "₹3999",
    shortDescription:
      "Book doctor appointments, run video consultations and store digital prescriptions securely.",
    description:
      "Develop a healthcare platform where patients search doctors, book appointments without slot conflicts, join video consultations via WebRTC and receive digital prescriptions — with encryption for sensitive data.",
    technologies: [
      "React",
      "Node.js",
      "Express.js",
      "MySQL",
      "WebRTC",
      "AWS",
    ],
    skills: [
      "WebRTC Integration",
      "Slot Conflict Prevention",
      "Data Encryption",
      "Schema Design",
      "Secure Deployment",
      "API Development",
    ],
    features: [
      "Doctor search",
      "Appointment booking",
      "Video consultation",
      "Digital prescriptions",
      "Slot conflict prevention",
      "Encrypted patient records",
    ],
    suitableFor: ["MCA", "B.Tech", "BE", "MSc CS"],
  },

  {
    id: "pet-adoption-rescue",
    title: "Pet Adoption and Rescue Platform",
    category: "Full Stack",
    domain: "Social Impact",
    difficulty: "Intermediate",
    duration: "6-8 Weeks",
    price: "₹2999",
    shortDescription:
      "List pets for adoption, manage shelters and process adoption applications end-to-end.",
    description:
      "Create a pet adoption platform where shelters list animals, users browse and filter by pet type and location, and applications flow through a tracked approval workflow with email notifications.",
    technologies: [
      "React",
      "Node.js",
      "Express.js",
      "PostgreSQL",
      "Cloudinary",
      "Nodemailer",
    ],
    skills: [
      "Image Uploads",
      "Search & Filter",
      "Application Workflow",
      "Email Notifications",
      "Schema Design",
      "Deployment",
    ],
    features: [
      "Pet listings",
      "Shelter management",
      "Adoption applications",
      "Search by type & location",
      "Image gallery",
      "Email notifications",
    ],
    suitableFor: ["BCA", "MCA", "B.Tech", "BE"],
  },

  {
    id: "language-learning-web-app",
    title: "Language Learning Web Application",
    category: "Full Stack",
    domain: "Education",
    difficulty: "Advanced",
    duration: "8-10 Weeks",
    price: "₹3499",
    shortDescription:
      "Lessons, flashcards with spaced repetition, quizzes, streaks and progress tracking.",
    description:
      "Build a language learning platform with structured lessons, spaced-repetition flashcards, quizzes and a streak system — packaged as a PWA for offline lesson access.",
    technologies: [
      "React",
      "Node.js",
      "Express.js",
      "MongoDB",
      "PWA",
      "Service Workers",
    ],
    skills: [
      "Spaced-Repetition Algorithm",
      "Streak Logic",
      "Quiz Scoring",
      "PWA & Offline Support",
      "React Development",
      "Deployment",
    ],
    features: [
      "Structured lessons",
      "Flashcards",
      "Quizzes",
      "Progress tracking",
      "Daily streaks",
      "Offline lesson access",
    ],
    suitableFor: ["BCA", "MCA", "B.Tech", "BE"],
  },

  {
    id: "news-aggregator-personalized-feed",
    title: "News Aggregator and Personalized Feed Platform",
    category: "Full Stack",
    domain: "Media",
    difficulty: "Advanced",
    duration: "8-10 Weeks",
    price: "₹3499",
    shortDescription:
      "Aggregate news from multiple sources, filter by category and get a personalized feed.",
    description:
      "Develop a news aggregator that pulls from multiple news APIs, deduplicates stories, caches responses and ranks a personalized feed based on user category preferences and bookmarks.",
    technologies: [
      "React",
      "Node.js",
      "Express.js",
      "MongoDB",
      "News APIs",
      "Redis",
    ],
    skills: [
      "Feed-Ranking Algorithm",
      "Article Deduplication",
      "API Caching",
      "Scheduled Fetching",
      "React Development",
      "Deployment",
    ],
    features: [
      "Multi-source aggregation",
      "Category filters",
      "Bookmarks",
      "Personalized feed",
      "Deduplication",
      "Periodic refresh",
    ],
    suitableFor: ["MCA", "B.Tech", "BE", "MSc CS"],
  },

  {
    id: "digital-library-ebook-reader",
    title: "Digital Library and E-Book Reading Platform",
    category: "Full Stack",
    domain: "Education",
    difficulty: "Advanced",
    duration: "8-10 Weeks",
    price: "₹3999",
    shortDescription:
      "Browse an e-book catalog, read books in-browser and sync bookmarks and progress across devices.",
    description:
      "Build a digital library with an in-browser e-reader, EPUB support, bookmarks, reading progress that syncs across devices, and search across the catalog — with book files served from S3/CloudFront.",
    technologies: [
      "React",
      "epub.js",
      "Node.js",
      "Express.js",
      "MongoDB",
      "AWS S3 / CloudFront",
    ],
    skills: [
      "E-Reader Integration",
      "Progress Sync",
      "Schema Design",
      "CDN Delivery",
      "React Development",
      "Deployment",
    ],
    features: [
      "E-book catalog",
      "In-browser reader",
      "Bookmarks",
      "Reading progress sync",
      "Search & filter",
      "S3 storage",
    ],
    suitableFor: ["MCA", "B.Tech", "BE", "MSc CS"],
  },

  {
    id: "online-auction-bidding",
    title: "Online Auction and Bidding Platform",
    category: "Full Stack",
    domain: "Marketplace",
    difficulty: "Advanced",
    duration: "8-10 Weeks",
    price: "₹3999",
    shortDescription:
      "List items, bid live with real-time updates, handle auction timers and capture payment on win.",
    description:
      "Build a live auction platform with WebSocket-driven bidding, automatic timer extension on late bids, race-condition-safe bid handling via Redis locks, and payment capture when an auction closes.",
    technologies: [
      "React",
      "Node.js",
      "Express.js",
      "MongoDB",
      "Socket.IO",
      "Redis",
    ],
    skills: [
      "Real-Time Bidding",
      "Redis Locking",
      "Race Condition Handling",
      "Auto-Extend Timers",
      "Payment Integration",
      "Deployment",
    ],
    features: [
      "Item listings",
      "Live bidding",
      "Auction timers",
      "Auto-extend on late bids",
      "Payment on win",
      "Bid history",
    ],
    suitableFor: ["MCA", "B.Tech", "BE", "MSc CS"],
  },
];

export default fsdProjects;